import axios from 'axios';

import { onResultType } from '../Contracts/types';

interface ICreateAxiosHttpConfigProps {
  baseURL?: string;
  timeout?: number;
  allowAnonymous?: boolean;
  token?: string;
}

export const createAxiosHttpConfig = ({
  allowAnonymous = false,
  timeout = 65000,
  ...props
}: ICreateAxiosHttpConfigProps) => {
  const httpConfig = axios.create({
    baseURL: props.baseURL,
    timeout: timeout,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  });

  if (allowAnonymous === false) {
    httpConfig.interceptors.request.use((request) => {
      const token = props.token ? props.token : localStorage.getItem('token');

      if (request !== undefined && request.headers !== undefined) {
        request.headers.Authorization = `Bearer ${token}`;
      }

      return request;
    });
  }

  return httpConfig;
};

export const onResultWithDataStatus: onResultType = (response) => {
  return {
    data: response.data,
    status: response.status,
  };
};

// A function that takes an object and returns a string of query parameters
export const objectToQuery = (obj: any) => {
  // Initialize an empty array to store the query parameters
  const params = [];
  // Get the keys of the object
  const keys = Object.keys(obj);
  // Loop through the keys
  for (const key of keys) {
    // Get the value of the key
    const value = obj[key];
    // If the value is not undefined or null, proceed
    if (value !== undefined && value !== null) {
      // Convert the value to a query parameter and push it to the array
      params.push(valueToQueryParam(key, value));
    }
  }
  // If the array is not empty, join the array elements with ampersands and add a question mark at the beginning
  if (params.length > 0) {
    return '?' + params.join('&');
  } else {
    // If the array is empty, return an empty string
    return '';
  }
};

// A helper function that converts a value to a query parameter with a given key name
export const valueToQueryParam = (key: any, value: any) => {
  // If the value is an array, loop through its elements and join them with ampersands
  if (Array.isArray(value)) {
    // Initialize an empty array to store the array elements as parameters
    const arrayParams = [];
    // Loop through the array elements
    for (const element of value) {
      // If the element is not undefined or null, proceed
      if (element !== undefined && element !== null) {
        // Append the element as a parameter with the key name and push it to the array
        arrayParams.push(`${key}=${element}`);
      }
    }
    // Join the array elements with ampersands and return them
    return arrayParams.join('&');
  } else {
    // If the value is not an array, return it as a parameter with the key name and value
    return `${key}=${value}`;
  }
};
